import { create } from "zustand";
import { persist } from "zustand/middleware";

export type ThemeMode = "light" | "dark" | "system";
export type ViewMode = "list" | "grid";
export type SortOrder = "name" | "updated" | "size";

interface UiState {
  sidebarCollapsed: boolean;
  viewMode: ViewMode;
  sortOrder: SortOrder;
  theme: ThemeMode;
  commandPaletteOpen: boolean;
  toggleSidebar: () => void;
  setViewMode: (mode: ViewMode) => void;
  setSortOrder: (order: SortOrder) => void;
  setTheme: (theme: ThemeMode) => void;
  setCommandPaletteOpen: (open: boolean) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      viewMode: "list",
      sortOrder: "name",
      theme: "system",
      commandPaletteOpen: false,
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setViewMode: (mode) => set({ viewMode: mode }),
      setSortOrder: (order) => set({ sortOrder: order }),
      setTheme: (theme) => set({ theme }),
      setCommandPaletteOpen: (open) => set({ commandPaletteOpen: open }),
    }),
    {
      name: "seadrive-ui",
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
        viewMode: state.viewMode,
        sortOrder: state.sortOrder,
        theme: state.theme,
      }),
    },
  ),
);
